// import { userService } from "../_services";
import { apiService } from "@/_services";
import router from "@/router";

const account = JSON.parse(localStorage.getItem("account"));

const initialState = account
  ? { status: { loggedIn: true }, user: account.user }
  : { status: { loggedIn: false }, user: null };

export default {
  namespaced: true,
  state: initialState,
  getters: {
    loggedIn(state) {
      return !!state.status.loggedIn;
    },
    loggingIn(state) {
      return !!state.status.loggingIn;
    },
    user(state) {
      return state.user;
    },
    canPublishApplications(state) {
      return state.status.loggedIn &&
        state.hasOwnProperty("user") &&
        state.user.hasOwnProperty("role") &&
        ["applicant_person", "applicant_business"].includes(state.user.role)
        ? true
        : false;
    }
  },
  actions: {
    login({ dispatch, commit }, { username, password }) {
      commit("loginRequest", { username });

      apiService.auth.login(username, password).then(
        data => {
          console.log(data);
          // login successful if there's a jwt token in the response
          if (data.jwt) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("account", JSON.stringify(data));
          }
          commit("loginSuccess", data.user);
          router.push("/finder/");
        },
        error => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        }
      );
    },
    refreshUser({ dispatch, commit }) {
      apiService.auth.getCurrentAccount().then(data => {
        commit("refreshUser", data.user);
        dispatch("notifications/setNotifications", data.notifications, {
          root: true
        });
      });
    },
    logout({ commit }) {
      localStorage.removeItem("account");
      commit("logout");
      router.push("/");
    }
  },
  mutations: {
    refreshUser(state, user) {
      // console.log("mutation[refreshUser]", user);
      state.user = user;
    },
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = { loggedIn: false };
      state.user = null;
    },
    logout(state) {
      state.status = { loggedIn: false };
      state.user = null;
    }
  }
};
